import React, { useEffect, useState, useRef, createElement } from 'react';
declare global {
  interface Window {
    tf?: any;
  }
}
export const CalendlyEmbed = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const scriptRef = useRef<HTMLScriptElement | null>(null);
  useEffect(() => {
    const loadTypeform = async () => {
      try {
        if (!scriptRef.current) {
          const script = document.createElement('script');
          script.src = '//embed.typeform.com/next/embed.js';
          script.async = true;
          script.onload = () => {
            if (window.tf) {
              setIsLoading(false);
            }
          };
          script.onerror = () => {
            console.error('Failed to load Typeform widget');
            setHasError(true);
            setIsLoading(false);
          };
          scriptRef.current = script;
          document.head.appendChild(script);
        }
      } catch (error) {
        console.error('Error loading Typeform:', error);
        setHasError(true);
        setIsLoading(false);
      }
    };
    loadTypeform();
    return () => {
      if (scriptRef.current && document.head.contains(scriptRef.current)) {
        document.head.removeChild(scriptRef.current);
      }
    };
  }, []);
  if (hasError) {
    return <div className="w-full max-w-6xl mx-auto mb-0" data-id="element-16">
        <p className="text-white text-center" data-id="element-17">
          Unable to load application form. Please refresh the page or try again
          later.
        </p>
      </div>;
  }
  return <div className="w-full max-w-6xl mx-auto mb-0" data-id="element-18">
      <div className="relative min-h-[550px] sm:min-h-[700px]" data-id="element-19">
        <div data-tf-live="01K5A8P8VE8QHBN1VCFXEA75M6" className="absolute inset-0" data-id="element-20" />
        {isLoading && <div className="absolute inset-0 flex items-center justify-center" data-id="element-21">
            <div className="flex flex-col items-center gap-4" data-id="element-22">
              <div className="animate-spin rounded-full h-12 w-12 border-4 border-white border-t-transparent" data-id="element-23" />
              <p className="text-white text-sm" data-id="element-24">Loading application form...</p>
            </div>
          </div>}
      </div>
    </div>;
};